import React from 'react';
import { states } from '../../../constants/orderStates'
import { Grid, Row, Col, Panel } from 'react-bootstrap';
import { Field, reduxForm } from "redux-form";
import { PhoneInput } from '../../common/PhoneInput';
import { MultiSelectField } from '../../common/Inputs';
import { validate as phoneValidate, required as phoneRequired, formatPhone } from '../../../extensions/phoneHelper';
import { render } from 'react-dom';

const validate = ({ phone }) => {
    const errors = {};
    if (!phoneRequired(phone) && phoneValidate(formatPhone(phone))) {
        errors.phone = '*Некорректный номер';
    }

    return errors;
}

let Filter = ({stateSelector}) => {
    const statesData = stateSelector ? stateSelector() : states;
    return (
        <Grid fluid={true} >
            <Row>
                <Col lg={12}>
                    <Panel>
                        <Panel.Heading>Фильтр</Panel.Heading>
                        <Panel.Body>
                            <form className='form-horizontal' style={{ display: 'flex' }} >
                                <Field name='phone' component={PhoneInput} label='Телефон' />
                                <Field name='states' component={MultiSelectField} useCustomStateComponent={true} data={statesData}
                                    valueField='Id'
                                    textField='Name'
                                    label='Статус' />
                            </form>
                        </Panel.Body>

                    </Panel>
                </Col>
            </Row>
        </Grid>);
}

Filter = reduxForm({
    form: 'allOrdersFilter',
    validate
})(Filter);

export default Filter;


// WEBPACK FOOTER //
// ./src/components/orders/filters/All.jsx